import Alert from './modules/_alert.js';
import Header from './modules/_header.js';
import Excerpt from './modules/_excerpt.js';
import ExternalURL from './modules/_external_links.js';
import FellowsRelated from './modules/_fellows-related.js';
import Flyout from './modules/_flyout.js';
import InView from './modules/_in-view.js';
import Popup from './modules/_popup.js';
import SectionNav from './modules/_section-nav.js';
import throttle from './base/_throttle.js';
import focusWithin from './base/_focus-within.js';
import objectFitCover from './base/_object-fit-cover.js';
import fitvid from "./base/_fitvid";

class Scripts {
	constructor() {
		document.addEventListener('DOMContentLoaded', this.ready.bind(this));
		window.addEventListener('resize', throttle(this.resize.bind(this), 25));
		this.resize();
	}

	ready() {
		focusWithin('label, form, fieldset');

		if (!('objectFit' in document.documentElement.style)) {
			objectFitCover('.object-fit-cover');
		}

		this.alert = new Alert();
		this.header = new Header();
		this.excerpt = new Excerpt();
		this.externalURL = new ExternalURL();
		this.fellowsRelated = new FellowsRelated();
		this.flyout = new Flyout();
		this.inView = new InView();
		this.sectionNav = new SectionNav();
		this.popup = new Popup();

		this.header.hamburger.addEventListener('click', () => this.flyout.open('menu'));
		this.header.search.addEventListener('click', () => this.flyout.open('search'));

		//fitvid();
	}

	resize() {
		if (!document.body) {
			return;
		}

		// using this to allow css to know if it should exclude the scroll bar in calc's
		if (window.innerWidth === document.body.clientWidth) {
			document.documentElement.classList.remove('has-scrollbar');
		} else {
			document.documentElement.classList.add('has-scrollbar');
		}
	}
}

export default new Scripts;
